import './App.css';

import { UserModel } from '@models/user/user.model';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import msalMockData from './mocks/data/msalMockData';
import userMockData from './mocks/data/userMockData';
import ReservationRouter from './routes/ReservationRouter';

function App(): React.ReactElement {
  return (
    <BrowserRouter>
      <ReservationRouter
        msalInstance={msalMockData}
        user={userMockData as UserModel}
      />
    </BrowserRouter>
  );
}

export default App;
